// How a media item's position is worded for admins (OQ-94, ADR 0009). The
// server words the PDF report's backfill the same way (functions.ts#pdfLocationText).

import i18n from '../../i18n/i18n';

type MediaPosition = {
  location?: { latitude: number; longitude: number } | null;
  locationAccuracy?: number | null;
};

// A position less accurate than this, in metres, is approximate.
export const APPROXIMATE_ACCURACY_M = 500;

const formatAccuracy = (metres: number) =>
  metres < 1000 ? `±${Math.round(metres)} m` : `±${(metres / 1000).toFixed(1)} km`;

const approximateAccuracy = ({ locationAccuracy }: MediaPosition) =>
  locationAccuracy != null && locationAccuracy > APPROXIMATE_ACCURACY_M ? locationAccuracy : undefined;

/** The admin UI's warning for an item, or undefined when its position needs none. */
export const describeMediaLocation = (item: MediaPosition): string | undefined => {
  if (!item.location) return i18n.t('shell.location.noPosition');
  const accuracy = approximateAccuracy(item);
  return accuracy === undefined
    ? undefined
    : i18n.t('shell.location.approximate', { accuracy: formatAccuracy(accuracy) });
};

/** The PDF report's "Geoposition:" value. */
export const pdfLocationText = (item: MediaPosition): string => {
  if (!item.location) return 'Ingen position';
  const coordinates = `[${item.location.latitude}, ${item.location.longitude}]`;
  const accuracy = approximateAccuracy(item);
  return accuracy === undefined ? coordinates : `${coordinates} (ungefärlig, ${formatAccuracy(accuracy)})`;
};
